import { stringify, stringifyOptions, isPlainObject } from './helpers';

const set: Set = (key, val, opts = {}) => {
  const skey: string = typeof key === 'string' ? key : '';
  const okey: Cookies = typeof key === 'string' ? {} : key;
  const cookies: Cookies = isPlainObject(key) ? okey : { [skey]: val };
  const optsString = stringifyOptions(opts);

  Object.keys(cookies).forEach(key => {
    document.cookie = `${key}=${stringify(cookies[key])}; ${optsString}`;
  });
};

const get: Get = key => {
  const match = document.cookie.match(new RegExp(`(${key})=(.*?)(;|$)`));

  return match ? match[2] : undefined;
};

const getAll: GetAll = () => {
  const cookies: Cookies = {};

  document.cookie
    .replace(/; /g, ';')
    .split(';')
    .map(cookie => cookie.split('='))
    .filter(([key]) => key)
    .forEach(([key, val]) => (cookies[key] = val));

  return cookies;
};

const remove: Remove = key => (document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`);

const clearAll: ClearAll = () =>
  document.cookie
    .replace(/; /g, ';')
    .split(';')
    .map(cookie => cookie.split('=')[0])
    .forEach(remove);

interface Cookies {
  [key: string]: string;
}
type Opts = { [key: string]: string };
type Get = (key: string) => string | undefined;
type Set = (key: string | Cookies, val: string, opts: Opts) => void;
type Remove = (key: string) => void;
type GetAll = () => Cookies;
type ClearAll = () => void;

interface ICookies {
  getAll: GetAll;
  set: Set;
  get: Get;
  remove: Remove;
  clearAll: ClearAll;
}
export const cookies: ICookies = { set, get, getAll, remove, clearAll };
